/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weeks: NonNullable<unknown> }} Progress_Extra_Rep_MetaInputs */

const en_us2_progress_extra_rep_meta = /** @type {(inputs: Progress_Extra_Rep_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`the last week`);
	return /** @type {LocalizedString} */ (`the last ${i?.weeks} weeks`)
	
};

const pt_br2_progress_extra_rep_meta = /** @type {(inputs: Progress_Extra_Rep_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`na última semana`);
	return /** @type {LocalizedString} */ (`nas últimas ${i?.weeks} semanas`)
	
};

const es_419_progress_extra_rep_meta = /** @type {(inputs: Progress_Extra_Rep_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`la última semana`);
	return /** @type {LocalizedString} */ (`las últimas ${i?.weeks} semanas`)
	
};

const pt_pt2_progress_extra_rep_meta = /** @type {(inputs: Progress_Extra_Rep_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`na última semana`);
	return /** @type {LocalizedString} */ (`nas últimas ${i?.weeks} semanas`)
	
};

const fr_fr2_progress_extra_rep_meta = /** @type {(inputs: Progress_Extra_Rep_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`la dernière semaine`);
	return /** @type {LocalizedString} */ (`les ${i?.weeks} dernières semaines`)
	
};

const de_de2_progress_extra_rep_meta = /** @type {(inputs: Progress_Extra_Rep_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`letzte Woche`);
	return /** @type {LocalizedString} */ (`letzte ${i?.weeks} Wochen`)
	
};

const it_it2_progress_extra_rep_meta = /** @type {(inputs: Progress_Extra_Rep_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`l'ultima settimana`);
	return /** @type {LocalizedString} */ (`le ultime ${i?.weeks} settimane`)
	
};

/**
* | weeks | output |
* | --- | --- |
* | "1" | "the last week" |
* | * | "the last {weeks} weeks" |
*
* @param {Progress_Extra_Rep_MetaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_rep_meta = /** @type {((inputs: Progress_Extra_Rep_MetaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Rep_MetaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_rep_meta(inputs)
	if (locale === "es-419") return es_419_progress_extra_rep_meta(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_rep_meta(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_rep_meta(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_rep_meta(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_rep_meta(inputs)
	return en_us2_progress_extra_rep_meta(inputs)
});
export { progress_extra_rep_meta as "progress-extra.rep_meta" }